import { getFirstPossibleRoute } from '@/router/utils/redirectHelpers'
import { type Route } from '@/types/route'

const roomManagementTabRoutes = [
  {
    path: 'student-accommodation',
    name: 'student-accommodation' as const,
    component: () =>
      import(
        '@/views/RoomManagement/StudentAccommodation/StudentAccommodationView.vue'
      ),
    meta: {
      icon: 'calendar',
      title: 'Student accommodation',
      permissions: ['boarding_accommodations.view_accommodation']
    }
  },
  {
    path: 'room-booking',
    name: 'room-booking' as const,
    component: () =>
      import('@/views/RoomManagement/RoomBooking/RoomBookingView.vue'),
    meta: {
      icon: 'book',
      title: 'Room booking',
      permissions: ['houses.view_houseroom']
    }
  }
] satisfies Route[]

export const roomManagementRoutes = [
  {
    path: 'room-management',
    name: 'room-management' as const,
    component: () => import('@/components/base/BaseLayout.vue'),
    props: {
      routes: roomManagementTabRoutes
    },
    meta: {
      title: 'Room management',
      icon: 'home',
      permissions: ['boarding_accommodations.view_accommodation']
    },
    redirect: () => getFirstPossibleRoute(roomManagementTabRoutes),
    children: roomManagementTabRoutes
  }
] satisfies Route[]
